'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isSet(value) {
    return value instanceof Set;
}
exports.isSet = isSet;
